var render = function render(){var _vm=this,_c=_vm._self._c;return _c('transition',{attrs:{"name":"page"},on:{"after-enter":_vm.afterEnter,"after-leave":_vm.afterLeave,"enter":_vm.enter,"leave":_vm.leave}},[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }